@if (messages().length) {
    <div class="cart-warning-banners" aria-live="polite" role="alert">
        @for (message of messages(); track message) {
            <lib-alert-message
                iconSize="small"
                type="warning"
                typography="body-2"
                [inline]="true"
                [text]="message"
            ></lib-alert-message>
        }
    </div>
}
